(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidIndividualController', CovidIndividualController);

    CovidIndividualController.$inject = ['$scope', '$state', 'CovidIndividual', 'CovidIndividualSearch'];

    function CovidIndividualController ($scope, $state, CovidIndividual, CovidIndividualSearch) {
        var vm = this;

        vm.covidIndividuals = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            CovidIndividual.query(function(result) {
                vm.covidIndividuals = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            CovidIndividualSearch.query({query: vm.searchQuery}, function(result) {
                vm.covidIndividuals = result;
            });
        }    }
})();
